import I18N from '@leverege/i18n';
import DataViewerModel from "../DataViewerModel.js";
import HistoryView from "./HistoryView.js";
import HistoryViewModel from "./models/HistoryViewModel.js";
import HistoryXYChartSupportDataViewer from "./HistoryXYChartSupportDataViewer.js";
import DataViewerModelUpdaterCreator from "../DataViewerModelUpdaterCreator.js";
const {
  tf,
  tfIcon
} = I18N.ns('molten.dataViewers.history.HistoryXYChartDataViewer');
export default {
  id: 'molten.dataViewer.history.HistoryXYChartDataViewer',
  type: 'molten.HistoryXYChart',
  name: tf('name'),
  icon: tfIcon('configIcon'),
  layout: {
    section: tf('section'),
    sort: 'd.b'
  },
  location: ['main', 'card'],
  matches: {
    type: ['ItemInfoDataViewer', 'GroupDataViewer']
  },
  settingsUpdaters: DataViewerModelUpdaterCreator.create('HistoryViewModelUpdater'),
  createSettings: props => {
    let mdl = HistoryViewModel.create({
      dataViewers: [DataViewerModel.create(HistoryXYChartSupportDataViewer.type, HistoryXYChartSupportDataViewer.createSettings(props))],
      breakpoints: []
    });
    mdl = HistoryViewModel.setPerPageEditable(mdl, false);
    mdl = HistoryViewModel.setPerPage(mdl, 500);
    mdl = HistoryViewModel.setAllPages(mdl, true);
    if (props.dataViewers.context?.type === 'ItemInfoDataViewer') {
      mdl = HistoryViewModel.setIsForItem(mdl, true);
    }
    return mdl;
  },
  component: HistoryView,
  getDefaultCardContentOptions: {
    height: '400px',
    needsDate: true,
    needsCondition: true,
    needsOrder: true
  }
};